import type { ComponentLike } from "@glint/template";

declare const IconsSparkles: ComponentLike<{ Element: SVGElement }>;
export default IconsSparkles;
